import React from "react";
import WhiteLogo from "../image/imperium-logo-white-new.png";
import DownArrow from "../image/down-arrow.png";
import SatoshiFont from "../fonts/Satoshi-Variable.woff2";
import { SITE_BASE } from "../utils/siteBase";

/*
  This component injects the EXACT same navbar HTML + CSS from the main website
  using dangerouslySetInnerHTML to bypass all React/Tailwind CSS interference.
*/

function SolutionsTopnav() {
  // Include the deployment sub-folder so main-site links resolve inside it
  // (e.g. https://host/imperium/about instead of https://host/about).
  const baseUrl = window.location.origin + SITE_BASE;

  const navbarHTML = `
<style>
  @font-face {
    font-family: 'Satoshi';
    src: url('${SatoshiFont}') format('woff2');
    font-style: normal;
  }

  /* === EXACT COPY: redesign.css navbar styles === */
  #imp-main-navbar * {
    box-sizing: border-box;
    font-family: 'Satoshi', sans-serif !important;
  }
  #imp-main-navbar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    line-height: normal;
  }
  #imp-main-navbar img {
    display: inline-block !important;
    max-width: none !important;
    vertical-align: middle;
  }
  #imp-main-navbar ul {
    display: flex;
    list-style: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  #imp-main-navbar li {
    display: block;
    padding: 0 !important;
    margin: 0 !important;
    list-style: none !important;
  }
  #imp-main-navbar .navbar-main {
    width: 100%;
    background: linear-gradient(90deg, #180E0A 0%, #151515 100%);
  }
  #imp-main-navbar .navbar-container {
    max-width: 1270px;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    padding: 16px 40px 16px 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  #imp-main-navbar .navbar-container-div-1 {
    width: 65%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  #imp-main-navbar .navbar-container-div-1 img {
    height: 42px;
    object-fit: contain;
    margin-top: 2px;
  }
  #imp-main-navbar .navbar-section-1 {
    padding: 0;
    margin: 0;
    display: flex;
    gap: 18px;
    flex-direction: row;
    align-items: center;
    list-style-type: none;
  }
  #imp-main-navbar .navbar-section-1 li a,
  #imp-main-navbar .dropdown-content a,
  #imp-main-navbar .sub-drop {
    font-size: 15px;
    font-weight: 500;
    line-height: 20.64px;
    letter-spacing: -0.03em;
    color: white;
    text-decoration: none;
  }
  #imp-main-navbar .navbar-section-1 li a:hover {
    color: #E9753B;
  }

  /* === EXACT COPY: navbar.blade.php inline styles === */
  #imp-main-navbar .dropdown-content {
    display: none;
    position: absolute;
    background: rgba(21, 21, 21, 0.95);
    -webkit-backdrop-filter: blur(12px);
    backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    min-width: 220px;
    box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.5);
    z-index: 1;
    border-radius: 8px;
    padding: 10px 0;
  }
  #imp-main-navbar .sub-drop {
    position: relative;
  }
  #imp-main-navbar .sub-drop-content {
    display: none;
    position: absolute;
    left: 100%;
    right: auto;
    top: 0;
    margin-left: 0;
    background: rgba(21, 21, 21, 0.95);
    -webkit-backdrop-filter: blur(12px);
    backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    min-width: 160px;
    box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.5);
    z-index: 1;
    border-radius: 8px;
  }
  /* Transparent hover-bridge: lets the mouse travel from "Technology Partner"
     into the Avaya/Cisco/... submenu without the hover dropping in the gap. */
  #imp-main-navbar .sub-drop-content::before {
    content: "";
    position: absolute;
    top: 0;
    left: -18px;
    width: 18px;
    height: 100%;
    background: transparent;
  }
  #imp-main-navbar .sub-drop:hover .sub-drop-content {
    display: block;
  }
  #imp-main-navbar .dropdown-content a, #imp-main-navbar .sub-drop {
    float: none;
    color: #ffffff !important;
    padding: 12px 20px;
    text-decoration: none;
    display: block;
    text-align: left;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  #imp-main-navbar .drop:hover .dropdown-content {
    display: block;
  }
  #imp-main-navbar .dropdown-content > a:hover, #imp-main-navbar .sub-drop:hover {
    background: rgba(255, 255, 255, 0.05) !important;
    color: #FF794A !important;
  }
  #imp-main-navbar .sub-drop-content a {
    background: transparent !important;
    color: #ffffff !important;
  }
  #imp-main-navbar .sub-drop-content a:hover {
    background: rgba(255, 255, 255, 0.05) !important;
    color: #FF794A !important;
  }
  #imp-main-navbar .arrow-for-nav {
    width: 10px !important;
    height: 10px !important;
    filter: brightness(0) invert(1);
    display: inline-block !important;
    vertical-align: middle !important;
    margin-top: -2px;
  }

  /* === CTA button (Talk to an Expert) - exact from redesign.css === */
  #imp-main-navbar .navbar-container-div-2 .butn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    border-radius: 8px;
    border: none;
    color: #fff;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
    background: linear-gradient(164.29deg, #FF794A -18.82%, #C16D1F 153.71%);
    padding: 8px 28px;
  }
  #imp-main-navbar .navbar-container-div-2 .butn:hover {
    color: #fff;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.3);
  }
  #imp-main-navbar .navbar-container-div-2 .butn span {
    z-index: 20;
    color: white;
    font-size: 15px;
    font-weight: 500;
    line-height: 20.64px;
    letter-spacing: -0.03em;
  }
  /* === Mobile responsive === */
  #imp-main-navbar .navbar-responsive {
    display: none;
    /* Match the main-site mobile navbar (redesign-responsive.css): 16px padding,
       not the desktop 40px. The larger padding squeezed the logo toward the
       "Talk to an Expert" button. */
    padding: 16px;
    background: linear-gradient(90deg, #180E0A 0%, #151515 100%);
    justify-content: space-between;
    align-items: center;
  }
  #imp-main-navbar .navbar-responsive .logo-responsive {
    /* Width-capped to 100px to match the main site, so the logo keeps a
       consistent size and spacing from the button on mobile. */
    width: 100px;
    height: auto;
    object-fit: contain;
    flex-shrink: 0;
  }
  #imp-main-navbar .hamburger-responsive {
    display: none;
    background: none;
    color: white;
    border: none;
    font-size: 24px;
    cursor: pointer;
  }
  /* === Mobile menu: matches main-site navbar.blade.php styling === */
  #imp-main-navbar .menu-responsive {
    display: none;
    list-style: none;
    flex-direction: column;
    background-color: black;
    position: absolute;
    top: 70px;
    right: 0;
    width: 100%;
    z-index: 10;
    padding: 0 10px !important;
    margin: 0 !important;
    max-height: calc(100vh - 70px);
    overflow-y: auto;
  }
  #imp-main-navbar .menu-responsive.show-responsive {
    display: flex;
  }
  #imp-main-navbar .menu-responsive > li {
    min-height: 40px;
    border-bottom: 0.2px solid gray;
    margin-top: 6px !important;
    color: #bab6b6;
    padding: 0 !important;
    display: block;
    flex-shrink: 0;
  }
  #imp-main-navbar .menu-responsive a,
  #imp-main-navbar .menu-responsive .resp-parent {
    color: #bab6b6;
    text-decoration: none;
    font-size: 15px;
    display: block;
    padding: 8px 6px;
    -webkit-tap-highlight-color: transparent;
  }
  #imp-main-navbar .menu-responsive a:hover,
  #imp-main-navbar .menu-responsive .resp-parent:hover {
    color: #E9753B;
  }
  #imp-main-navbar .menu-responsive .resp-parent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 20px;
    cursor: pointer;
    user-select: none;
  }
  #imp-main-navbar .menu-responsive .arrow-responsive .arrow-for-nav {
    width: 10px !important;
    height: 10px !important;
    filter: brightness(0) invert(1);
    transition: transform 0.2s ease;
  }
  /* second level */
  #imp-main-navbar .submenu-responsive {
    display: none;
    list-style: none;
    width: 100%;
    padding: 0 !important;
    margin: 4px 0 0 !important;
    background-color: rgb(98, 97, 97);
  }
  #imp-main-navbar .submenu-responsive.show-responsive {
    display: block;
  }
  #imp-main-navbar .submenu-responsive > li {
    min-height: 38px;
    font-size: 14px;
    border-bottom: none;
    padding: 0 !important;
    margin: 0 !important;
    display: block;
  }
  #imp-main-navbar .submenu-responsive a,
  #imp-main-navbar .submenu-responsive .resp-parent {
    color: #bab6b6;
    font-size: 14px;
    padding: 9px 12px;
  }
  /* third level */
  #imp-main-navbar .sub-drop-responsive { width: 100%; }
  #imp-main-navbar .drop-content-responsive {
    display: none;
    list-style: none;
    width: 100%;
    padding: 0 !important;
    margin: 0 !important;
    background-color: #000;
  }
  #imp-main-navbar .drop-content-responsive.show-responsive {
    display: block;
  }
  #imp-main-navbar .drop-content-responsive a {
    color: #fff !important;
    padding: 9px 22px !important;
  }
  #imp-main-navbar .navbar-container-div-2 button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(164.29deg, #FF794A -18.82%, #C16D1F 153.71%);
    padding: 8px 20px;
    border: none;
    border-radius: 8px;
    white-space: nowrap;
    cursor: pointer;
  }
  #imp-main-navbar .navbar-container-div-2 button a {
    display: block;
    color: white;
    font-size: 12px;
    font-weight: 500;
    line-height: 1;
    letter-spacing: -0.03em;
    text-decoration: none;
  }

  @media (max-width: 1100px) {
    #imp-main-navbar .navbar-responsive {
      display: flex;
    }
    #imp-main-navbar .navbar-main {
      display: none;
    }
    #imp-main-navbar .hamburger-responsive {
      display: block;
    }
  }
</style>

<!-- === EXACT COPY: navbar.blade.php HTML structure === -->
<header id="imp-main-navbar">
  <div class="navbar-main">
    <div class="navbar-container">
      <div class="navbar-container-div-1">
        <a href="${baseUrl}"><img src="${WhiteLogo}" alt="logo" style="cursor: pointer;"/></a>
        <ul class="navbar-section-1">
          <li id="aboutli"><a href="${baseUrl}/about">About Us</a></li>
          <li id="productsli"><a href="${baseUrl}/products">Products</a></li>
          <li id="solutionsli"><a href="${baseUrl}/industry-influence">Verticals</a></li>
          <li id="solutionsli1"><a href="#/solutions">Solutions</a></li>
          <li><a href="${baseUrl}/casestudy">Case Studies</a></li>
          <li id="partnersli" class="drop"><a href="javascript:;">Partners <span style="margin-left: 5px;" class="arrow-responsive"><img class="arrow-for-nav" src="${DownArrow}" alt=""></span></a>
            <div class="dropdown-content">
              <a href="#/strategic-partnerships">Strategic Partnership</a>
              <div class="sub-drop">Technology Partner
                <div class="sub-drop-content">
                  <a href="${baseUrl}/cx/#/Avaya_CX">Avaya</a>
                  <a href="${baseUrl}/partners-cisco">Cisco</a>
                  <a href="${baseUrl}/partners-microsoft-lync">Microsoft Lync</a>
                </div>
              </div>
              <a href="${baseUrl}/partners-microsoft-lync">Channel Partner</a>
            </div>
          </li>
          <li id="inaipili" class="drop"><a href="javascript:;">Cloud<span style="margin-left: 5px;" class="arrow-responsive"><img class="arrow-for-nav" src="${DownArrow}" alt=""></span></a>
            <div class="dropdown-content">
              <a href="${baseUrl}/inaipi"> INAIPI Cloud</a>
              <a href="${baseUrl}/avaya">Avaya Cloud</a>
            </div>
          </li>
          <li id="contactli"><a href="${baseUrl}/blog-news">Blog</a></li>
        </ul>
      </div>
      <div class="navbar-container-div-2">
        <a class="butn butn__new" href="${baseUrl}/contact"><span>Talk to an Expert</span></a>
      </div>
    </div>
  </div>

  <nav class="navbar-responsive">
    <a href="${baseUrl}"><img class="logo-responsive" src="${WhiteLogo}" alt="logo" style="cursor: pointer;" /></a>
    <div style="display: flex; align-items:center; gap:16px">
      <div class="navbar-container-div-2">
        <button><a href="${baseUrl}/contact">Talk to an Expert</a></button>
      </div>
      <button class="hamburger-responsive" aria-label="Toggle menu" onclick="document.getElementById('mobileMenuImp').classList.toggle('show-responsive')">☰</button>
    </div>
    <ul class="menu-responsive" id="mobileMenuImp" onclick="if(event.target.closest('a')){this.classList.remove('show-responsive')}">
      <li><a href="${baseUrl}/about">About Us</a></li>
      <li><a href="${baseUrl}/products">Products</a></li>
      <li><a href="${baseUrl}/industry-influence">Verticals</a></li>
      <li><a href="#/solutions">Solutions</a></li>
      <li><a href="${baseUrl}/casestudy">Case Studies</a></li>
      <li class="has-submenu-responsive">
        <div class="resp-parent" onclick="this.nextElementSibling.classList.toggle('show-responsive')"><span>Partners</span> <span class="arrow-responsive"><img class="arrow-for-nav" src="${DownArrow}" alt=""></span></div>
        <ul class="submenu-responsive">
          <li><a href="#/strategic-partnerships">Strategic Partnership</a></li>
          <li>
            <div class="sub-drop-responsive">
              <div class="resp-parent" onclick="this.nextElementSibling.classList.toggle('show-responsive')"><span>Technology Partner</span> <span class="arrow-responsive"><img class="arrow-for-nav" src="${DownArrow}" alt=""></span></div>
              <ul class="drop-content-responsive">
                <li><a href="${baseUrl}/cx/#/Avaya_CX">Avaya</a></li>
                <li><a href="${baseUrl}/partners-cisco">Cisco</a></li>
                <li><a href="${baseUrl}/partners-microsoft-lync">Microsoft Lync</a></li>
              </ul>
            </div>
          </li>
          <li><a href="${baseUrl}/partners-microsoft-lync">Channel Partner</a></li>
        </ul>
      </li>
      <li class="has-submenu-responsive">
        <div class="resp-parent" onclick="this.nextElementSibling.classList.toggle('show-responsive')"><span>Cloud</span> <span class="arrow-responsive"><img class="arrow-for-nav" src="${DownArrow}" alt=""></span></div>
        <ul class="submenu-responsive">
          <li><a href="${baseUrl}/inaipi">INAIPI Cloud</a></li>
          <li><a href="${baseUrl}/avaya">Avaya Cloud</a></li>
        </ul>
      </li>
      <li><a href="${baseUrl}/blog-news">Blog</a></li>
    </ul>
  </nav>
</header>
`;

  return (
    <div dangerouslySetInnerHTML={{ __html: navbarHTML }} />
  );
}

export default SolutionsTopnav;
